import {
  GET_NOTIFICATIONS_EMAIL,
  GET_NOTIFICATIONS_EMAIL_SUCCESS,
  GET_NOTIFICATIONS_EMAIL_FAIL,
  DELETE_NOTIFICATION_EMAIL,
  DELETE_NOTIFICATION_EMAIL_SUCCESS,
  DELETE_NOTIFICATION_EMAIL_FAIL,
  EDIT_NOTIFICATION_EMAIL,
  EDIT_NOTIFICATION_EMAIL_SUCCESS,
  EDIT_NOTIFICATION_EMAIL_FAIL,
  GET_AREA,
  GET_AREA_SUCCESS,
  GET_AREA_FAIL,
  SAVE_NOTIFICATION_EMAIL,
  SAVE_NOTIFICATION_EMAIL_SUCCESS,
  SAVE_NOTIFICATION_EMAIL_FAIL,
  CLEAN_NOTIFICATIONS_EMAIL,
  SEND_EMAIL,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_FAIL
} from "./actionTypes"

const INIT_STATE = {
  notificationEmailList: {
    notificationEmailList: [],
    size: 0,
  },
  statusOrder: [],
  error: "",
  loading: true,
  loadingSave: false,
  response: null,
  responseDelete: null,
  responseEmail: null
}

const notificationsEmail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS_EMAIL:
      return {
        ...state,
        notificationEmailList: [],
        loading: true,
        loadingSave: true
      }
    case GET_NOTIFICATIONS_EMAIL_SUCCESS:
      return {
        ...state,
        notificationEmailList: action.payload.data,
        loading: false,
        loadingSave: false
      }

    case GET_NOTIFICATIONS_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loadingSave: false
      }
    case EDIT_NOTIFICATION_EMAIL:
      return {
        ...state,
        loadingSave: true,
        loading: true,
        error: "",
        response: null
      }
    case EDIT_NOTIFICATION_EMAIL_SUCCESS:
      return {
        ...state,
        loadingSave: false,
        error: "",
        response: action.payload
      }
    case EDIT_NOTIFICATION_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case DELETE_NOTIFICATION_EMAIL_SUCCESS:
      return {
        ...state,
        responseDelete: action.payload.data,
        loading: false
      }
    case DELETE_NOTIFICATION_EMAIL:
      return {
        ...state,
        responseDelete: null,
        loading: true,
      }
    case DELETE_NOTIFICATION_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case GET_AREA:
      return {
        ...state,
        statusOrder: [],
        loading: true
      }
    case GET_AREA_SUCCESS:
      return {
        ...state,
        statusOrder: action.payload,
        loading: false
      }

    case GET_AREA_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case SAVE_NOTIFICATION_EMAIL:
      return {
        ...state,
        loadingSave: true,
        response: null,
        loading: true
      }
    case SAVE_NOTIFICATION_EMAIL_SUCCESS:
      return {
        ...state,
        loadingSave: false,
        error: "",
        response: action.payload.data,
      }

    case SAVE_NOTIFICATION_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingSave: false,
        response: null,
        loading: false,
      }
    case CLEAN_NOTIFICATIONS_EMAIL:
      return {
        ...state,
        error: "",
        loadingSave: false,
        response: null,
        responseDelete: null,
      }
    case SEND_EMAIL:
      return {
        ...state,
        response: null
      }
    case SEND_EMAIL_SUCCESS:
      return {
        ...state,
        error: "",
        responseEmail: action.payload,
      }

    case SEND_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
        responseEmail: null,
      }
    default:
      return state
  }
}

export default notificationsEmail